<template>
  <div>
      <main-header></main-header>
      <div class="registermain">
          <div class="w1200 registerbg">
              <div class="registerformbox">
                  <div class="title">{{language[languagetype].title}}</div>
                  <div class="inputbox">
                    <span>*</span>
                    <input type="text" :placeholder="language[languagetype].userplea" v-model="name">
                  </div>
                  <div class="inputbox">
                    <span>*</span>
                    <input type="password" :placeholder="language[languagetype].passwordplea" v-model="password">
                  </div>
                  <div class="inputbox">
                    <span>*</span>
                    <input type="password" :placeholder="language[languagetype].newpasswordplea" v-model="newpassword">
                  </div>
                  <div class="inputbox">
                    <span>*</span>
                    <input type="password" :placeholder="language[languagetype].relnewpasswordplea" v-model="renewpassword">
                  </div>
                  <div class="inputbox2">
                    <span>*</span>
                    <input type="text" :placeholder="language[languagetype].code" v-model="code">
                    <div class="codetext">{{codetext}}</div>
                  </div>
                  <div class="submitbtn" @click="submit">
                      {{language[languagetype].ok}}
                  </div>
              </div>
          </div>
      </div>
      <toast ref="toasttext"></toast>
  </div>
</template>

<script>
import MainHeader from './header'
import httppost from '../js/ajax'
import toast from '../components/taast/toast'
let languagetext = require('../js/forget.json')
export default {
  name: 'index',
  data () {
    return {
      codepic: '',
      name: '',
      password: '',
      newpassword: '',
      renewpassword: '',
      code: '',
      codetext: '',
      lang: 1,
      language: {},
      languagetype: 'cn'
    }
  },
  methods: {
    submit: function () {
      const that = this
      if (that.name === '') {
        that.$refs.toasttext.show('请填写账号信息!')
        return false
      }
      if (that.password === '') {
        that.$refs.toasttext.show('请填写密码信息!')
        return false
      }
      if (that.newpassword === '') {
        that.$refs.toasttext.show('请填写新密码信息!')
        return false
      }
      if (that.newpassword !== that.renewpassword) {
        that.$refs.toasttext.show('两次密码输入不一致!')
        return false
      }
      if (that.code == null || that.code === '') {
        that.$refs.toasttext.show('请填写验证码信息!')
        that.coderefresh()
        return false
      }
      if (that.code !== that.codetext) {
        that.$refs.toasttext.show('验证码错误！')
        that.coderefresh()
        return false
      }
      httppost.post('Api/http', {
        name: 'portal.login.update',
        account: that.name,
        oldPassword: that.password,
        newPassword: that.newpassword
      }).then((res) => {
        if (res.code !== '0') {
          that.$refs.toasttext.show('修改密码失败')
        } else {
          that.$refs.toasttext.show('修改密码成功')
          setTimeout(function () {
            that.$router.push({name: 'login'})
          }, 1000)
        }
      }).catch(err => {
        that.$refs.toasttext.show('修改密码失败')
        console.log(err)
        that.codenum++
        that.coderefresh()
      })
    },
    coderefresh: function () {
      const that = this
      that.codetext = ''
      var codeChars = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z' ]
      for (var i = 0; i < 4; i++) {
        that.codetext = codeChars[Math.floor(Math.random() * 36)] + this.codetext
      }
    }
  },
  created () {
    this.coderefresh()
    const that = this
    that.language = languagetext
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
    that.username = JSON.parse(localStorage.getItem('username'))
    if (that.username == null) {
      setTimeout(function () {
        that.$refs.toasttext.show('您还未登录,请登录')
      }, 300)
      setTimeout(function () {
        that.$router.push({name: 'login'})
      }, 1000)
    }
  },
  components: {
    MainHeader, toast
  },
  beforeCreate () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.registermain{min-height: 683px;background-color: #F6F6F6;overflow: hidden;}
.registerbg{height: 580px;margin-top: 50px;background-color: #Fff;}
.registerformbox{width: 310px;height: 100%;overflow: hidden;margin: 0 auto;}
.registerformbox .title{width: 100%;height: 85px;line-height: 85px;margin-top: 16px;text-align: center;font-size: 30px;color: #333333;}
.inputbox{width: 100%;height: 40px;overflow: hidden;display: flex;margin-bottom: 28px;}
.inputbox span{width: 10px;flex-shrink: 0;line-height: 40px;font-size: 16px;color: red;}
.inputbox input{border: none;outline: none;flex: 1;min-width: 80px;border-bottom: 1px solid #c5c5c5;}
.inputbox2{width: 100%;height: 40px;overflow: hidden;display: flex;margin-bottom: 28px;}
.inputbox2 input{border: none;outline: none;flex: 1;margin-right: 5px;border-bottom: 1px solid #c5c5c5;}
.inputbox2 span{width: 10px;flex-shrink: 0;line-height: 40px;font-size: 16px;color: red;}
.inputbox2 .codetext{width: 30%;height: 40px;background-color: #D8B7E3;display: flex;align-items: center;justify-content: center;font-size: 16px;}
.inputbox .pic{width: 110px;height: 45px;margin-left: 46px;}
.submitbtn{width: 100%;height: 50px;background-color: #1C5CEF;text-align: center;line-height: 50px;font-size: 20px;color: #fff;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/page/forget.vue